/**
 * Opengater scheduler-jobs hooks (users service, `admin: scheduler-jobs`).
 * A fixed list of jobs — no create/delete, only per-job schedule updates.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/api/v1/admin/scheduler-jobs';
const KEY = ['og', 'scheduler'];
export function useOgSchedulerJobs() {
    return useQuery({
        queryKey: KEY,
        queryFn: () => apiOg('users', PATH),
    });
}
export function useUpdateOgSchedulerJob(jobName) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', `${PATH}/${encodeURIComponent(jobName)}`, {
            method: 'PUT',
            body: patch,
        }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
